 <template>
  <section class="section columns">
    <div
      class="box container ticket-container column is-two-thirds"
      :class="{'is-loading':isLoading}"
      v-if="!ticketCreated"
    >
      <h2 class="title">Support</h2>
      <p>If you are experiencing any technical difficulties, please complete a support ticket below briefly explaining your experience, and one of our team will be in contact with you shortly.</p>
      <form @submit.prevent="submitTicket">
        <div class="field">
          <!-- <label
            class="label has-text-left has-text-weight-semibold"
          >Describe the issue that you are experiencing?</label>-->

          <textarea
            v-model="description"
            name="description"
            placeholder="Describe your issue..."
            class="textarea"
            required
          ></textarea>
        </div>

        <button
          icon="far fa-save"
          :centered="false"
          :prevent="true"
          class="button"
          @click.prevent="submitTicket"
        >Submit Ticket</button>
      </form>
    </div>
    <div class="box container column is-two-thirds profileContainer" v-else>
      <h2 class="subtitle">Ticket Created!</h2>
      <p>We will be in contact shortly.</p>
    </div>
  </section>
</template>

<script>
import { ACCESS_TOKEN, API_URL } from "../../Variables";
import BaseHelper from "../../helpers/BaseHelper";
import { SupportClient } from "../../clients/SupportClient.js";

export default {
  name: "TicketForm",
  mixins: [BaseHelper],
  components: {},

  computed: {},
  data() {
    return {
      access_token: ACCESS_TOKEN,
      isLoading: false,
      description: "",
      ticketCreated: false
    };
  },
  mounted() {},
  methods: {
    submitTicket: function() {
      this.isLoading = true;
      let payload = {
        description: this.description
      };
      SupportClient.createTicket(payload)
        .then(response => {
          this.description = "";
          this.ticketCreated = true;
        })
        .then(() => {
          this.isLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" >
@import "@/assets/scss/variables.scss";
@import "@/assets/scss/support.scss";
</style>